
import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const { t } = useTranslation();
  const { direction } = useLanguage();
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/login');
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-gradient-to-b from-synagogue-light to-white opacity-90 z-0"></div>
      
      {/* Star of David pattern (abstract decorative elements) */}
      <div className="absolute top-40 right-20 w-96 h-96 opacity-10 rotate-12 z-0">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="M50 0L63 37.5L100 50L63 62.5L50 100L37 62.5L0 50L37 37.5L50 0Z" fill="#1C2B5E"/>
        </svg>
      </div>
      <div className="absolute bottom-40 left-20 w-64 h-64 opacity-10 -rotate-12 z-0">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="M50 0L63 37.5L100 50L63 62.5L50 100L37 62.5L0 50L37 37.5L50 0Z" fill="#D3A84F"/>
        </svg>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 py-20 relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          {/* Hero Text */}
          <div className={`${direction === 'rtl' ? 'md:order-2' : ''} w-full md:w-1/2 md:pr-12 text-center md:text-left mb-10 md:mb-0`}>
            <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-synagogue-blue ${direction === 'rtl' ? 'text-right' : 'text-left'}`}>
              {t('heroTitle')}
            </h1>
            <p className={`text-xl md:text-2xl mb-8 text-gray-700 ${direction === 'rtl' ? 'text-right' : 'text-left'}`}>
              {t('heroSubtitle')}
            </p>
            <div className={`${direction === 'rtl' ? 'text-right' : 'text-left'}`}>
              <Button
                onClick={handleSignUp}
                className="bg-synagogue-gold hover:bg-synagogue-blue text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors shadow-md"
              >
                {t('heroButton')}
              </Button>
            </div>
          </div>
          
          {/* Hero Image */}
          <div className={`${direction === 'rtl' ? 'md:order-1' : ''} w-full md:w-1/2`}>
            <div className="rounded-xl shadow-xl overflow-hidden bg-white">
              <img 
                src="https://images.unsplash.com/photo-1466442929976-97f336a657be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="Digital Synagogue Display" 
                className="w-full h-auto object-cover"
                onError={(e) => {
                  // Fallback if image doesn't load
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://placehold.co/600x400/FDF8E3/1C2B5E?text=Digital+Display+Board';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
